var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatGpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91675 1.3335C5.91675 0.919283 6.25253 0.583496 6.66675 0.583496H10.0001C10.4143 0.583496 10.7501 0.919283 10.7501 1.3335V4.66683C10.7501 5.08104 10.4143 5.41683 10.0001 5.41683C9.58587 5.41683 9.25008 5.08104 9.25008 4.66683V2.0835H6.66675C6.25253 2.0835 5.91675 1.74771 5.91675 1.3335Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00016 5.41699C4.4939 5.41699 4.0835 5.8274 4.0835 6.33366V13.0003C4.0835 13.5066 4.4939 13.917 5.00016 13.917H15.0002C15.5064 13.917 15.9168 13.5066 15.9168 13.0003V6.33366C15.9168 5.8274 15.5064 5.41699 15.0002 5.41699H5.00016ZM2.5835 6.33366C2.5835 4.99897 3.66547 3.91699 5.00016 3.91699H15.0002C16.3349 3.91699 17.4168 4.99897 17.4168 6.33366V13.0003C17.4168 14.335 16.3349 15.417 15.0002 15.417H5.00016C3.66547 15.417 2.5835 14.335 2.5835 13.0003V6.33366Z",
    fill: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50008 8.0835C7.91429 8.0835 8.25008 8.41928 8.25008 8.8335V10.5002C8.25008 10.9144 7.91429 11.2502 7.50008 11.2502C7.08587 11.2502 6.75008 10.9144 6.75008 10.5002V8.8335C6.75008 8.41928 7.08587 8.0835 7.50008 8.0835ZM12.5001 8.0835C12.9143 8.0835 13.2501 8.41928 13.2501 8.8335V10.5002C13.2501 10.9144 12.9143 11.2502 12.5001 11.2502C12.0859 11.2502 11.7501 10.9144 11.7501 10.5002V8.8335C11.7501 8.41928 12.0859 8.0835 12.5001 8.0835ZM0.916748 9.66683C0.916748 9.25262 1.25253 8.91683 1.66675 8.91683H3.33341C3.74763 8.91683 4.08341 9.25262 4.08341 9.66683C4.08341 10.081 3.74763 10.4168 3.33341 10.4168H1.66675C1.25253 10.4168 0.916748 10.081 0.916748 9.66683ZM15.9167 9.66683C15.9167 9.25262 16.2525 8.91683 16.6667 8.91683H18.3334C18.7476 8.91683 19.0834 9.25262 19.0834 9.66683C19.0834 10.081 18.7476 10.4168 18.3334 10.4168H16.6667C16.2525 10.4168 15.9167 10.081 15.9167 9.66683Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatGpt);
export default __webpack_public_path__ + "static/media/chat-gpt.acaff509864e44f36e85f2fd5aa01fbb.svg";
export { ForwardRef as ReactComponent };